export default {
    path: '',
    component: () => import(`@/component/admin-layout/index.vue`),
    children: [
        {
            path: '/admin/yinzhilv/demo-TravelCitySelector',
            name: 'admin-yinzhilv-demo-TravelCitySelector',
            component: () => import(`./index.vue`),
            meta: {
                entity_for_history_tag: {
                    name: `demo-TravelCitySelector`,
                },
                entity_list_for_breadcrumb: [
                    {name: `demo`},
                    {name: `demo-TravelCitySelector`},
                ],
                skip_check_token: true,
            },
        },
    ],
};
